import { createElement } from "/elements_functions/new_elements.js";
import {logOut} from '/login/logout.js';
import { makeNewButton } from '/buttons_functions/custom_button_functions.js';
import {API_GATEWAY, SITE_URL} from '/constants/API_constants.js';

export function createLoadingScreen(screenVerticalTopPX, screenVerticalBottomPX, circleSizePX) {
    const loadingScreen = createElement('div', null, ['loading-screen']);
    loadingScreen.style.padding = `${Math.abs(screenVerticalTopPX-circleSizePX/2)}px 0 ${Math.abs(screenVerticalBottomPX-circleSizePX/2)}px 0`;

    const loadingCircle = createElement('div', null, ['loading-circle-box']);
    loadingCircle.style.width = `${circleSizePX}px`;
    loadingCircle.style.height = `${circleSizePX}px`;
    loadingCircle.style.position = 'relative';
    const circleBig = createElement('img', null, ['loading-circle-big', 'loading-circle']);
    circleBig.src = '/images/big1.png';
    circleBig.style.width = `${circleSizePX*0.75}px`;
    circleBig.style.height = `${circleSizePX*0.75}px`;
    const circleSmall = createElement('img', null, ['loading-circle-small', 'loading-circle']);
    circleSmall.src = '/images/big1.png';
    circleSmall.style.width = `${circleSizePX*0.55}px`;
    circleSmall.style.height = `${circleSizePX*0.55}px`;

    loadingCircle.append(circleBig);
    loadingCircle.append(circleSmall);

    const loadingCaption = createElement('p', null, null);
    loadingCaption.style.fontSize = `${circleSizePX*0.15}px`;
    loadingCaption.innerText = 'Loading...';

    loadingScreen.append(loadingCircle);
    loadingScreen.append(loadingCaption);

    loadingScreen.loadingCircle = loadingCircle;
    loadingScreen.loadingCaption = loadingCaption;

    return loadingScreen;
}